var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.925 18.204l-5.646-6.16a7.076 7.076 0 001.971-4.919 7.078 7.078 0 00-2.087-5.038A7.078 7.078 0 007.125 0a7.078 7.078 0 00-5.038 2.087A7.078 7.078 0 000 7.125c0 1.903.741 3.692 2.087 5.038a7.078 7.078 0 005.038 2.087 7.07 7.07 0 004.454-1.563l5.646 6.159a.474.474 0 10.7-.642zM.95 7.125A6.182 6.182 0 017.125.95 6.182 6.182 0 0113.3 7.125 6.182 6.182 0 017.125 13.3 6.182 6.182 0 01.95 7.125z",
    fill: "#4A494B"
  })));
}

export default SvgSearchIcon;